var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableTemplate',{attrs:{"blocked":!_vm.hasAccess(_vm.TARIFF_PLAN.PREMIUM),"title":_vm.$t('options.chainPlanets'),"alwaysDrawContent":true},on:{"toggle":_vm.onTableToggle}},[_c('div',{staticClass:"chains-container",class:{ 'ph-loading--content': _vm.showSkeleton }},[_c('div',{attrs:{"id":"graph"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }